import { Controller } from "remult";

@Controller("user-population-methods")
export class UserPopulationMethods {}







